module.exports = __webpack_public_path__ + "img/profile-pic.9c7999b7.jpg";